// Shared API base helper to work on localhost and LAN.
const protocol = window.location.protocol;
const host = window.location.hostname;

// Default to same host that served the app; override with REACT_APP_API_BASE when needed.
// export const API_BASE =
//   (process.env.REACT_APP_API_BASE || `${protocol}//${host}`) + "/pethanatchi";

export const API_BASE =
  (process.env.REACT_APP_API_BASE || "https://api.techwellpro.com/pethanatchi_php") ;


